module.exports = __webpack_public_path__ + "static/img/sample01.32ccefa1.svg";